import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
export function Header() {
  return <header className="w-full border-b border-gold/10 bg-charcoal/80 backdrop-blur-md sticky top-0 z-50" data-id="element-74">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-75">
        <div className="font-serif text-2xl tracking-widest text-ivory" data-id="element-76">
          UNHOOKED
        </div>
        <button className="text-ivory/70 hover:text-ivory transition-colors flex items-center gap-2 text-sm uppercase tracking-wider" data-id="element-77">
          <ShoppingBagIcon className="w-4 h-4" data-id="element-78" />
          <span className="hidden sm:inline" data-id="element-79">Cart</span>
        </button>
      </div>
    </header>;
}